import { FolioFileObject } from "./FolioFileObject";

export class FolioFileRequest {
   requestObject: FolioFileObject;
   file: File;
}
